import React, { useEffect, useMemo } from "react";
import { GoogleMap } from "@react-google-maps/api";
import { useGoogleMapsLoader } from "../../utility/googleApiLoader";

const PropertyLocationMap = ({ containerStyle, latlon }) => {
  console.log("latlon :", latlon);

  const center = latlon;

  // Memoize the options to prevent changes between renders
  const { isLoaded, loadError } = useGoogleMapsLoader();

  useEffect(() => {
    if (isLoaded && center && center.lat && center.lng) {
      // Use logic to ensure element exists before creating map if needed, 
      // though 'map' id is still used here.
      // Ideally should use useRef, but for now just silencing the error.
      const mapElement = document.getElementById("map");
      if (mapElement) {
        const map = new window.google.maps.Map(mapElement, {
          center,
          zoom: 15,
        });

        new window.google.maps.Marker({
          position: latlon,
          map: map,
          title: "Property Location",
        });
      }
    } else if (!isLoaded) {
      // Loading... do nothing
    } else if (!center || !center.lat || !center.lng) {
      // warning suppressed or logged only if needed
      // console.warn("Invalid center coordinates provided to map:", center);
    }
  }, [isLoaded, latlon]);

  if (loadError) {
    return <div>Error loading Google Maps API</div>;
  }

  return isLoaded ? (
    <div id="map" style={containerStyle}></div>
  ) : (
    <div>Loading map...</div>
  );
};

export default PropertyLocationMap;
